import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_60: FaireProductEntity = {
  token: "legacy_prod_abbott-60",
  type: "product",
  name: 'Small Pomegranate Shaped Bowl 4.5" L',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/00d287bee5c94accd7dbfbb6aeb803ada7118eec7e5fbd217e115ee84c0efe95.jpeg",
  priceDollars: 16,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
